/* global angular, $ */
angular.module('ua5App.index.artist')
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('index.artist', {
            url: ':artist?index&show_response',
            templateUrl: 'states/index.artist/index.artist.html',
            controller: 'ArtistCtrl',
            controllerAs: 'ctrl',
            reloadOnSearch: false
        });
    }])
    .run(['$rootScope', function($rootScope) {
        var body = angular.element('body');
        body.bind('keydown', function(e) {
            var keyCode = e.keyCode;
            // Left arrow
            if (keyCode === 37) {
                $rootScope.$broadcast('artist:leftArrowClicked');
            }
            // Right arrow
            if (keyCode === 39) {
                $rootScope.$broadcast('artist:rightArrowClicked');
            }
        });
    }])
    .controller('ArtistCtrl', [
    'posts',
    '$filter',
    '$stateParams',
    '$rootScope',
    '$scope',
    '$timeout',
    'MetaFactory',
    'PreviousState',
    'ModalService',
    '$location',
    function(posts, $filter, $stateParams, $rootScope, $scope, $timeout, MetaFactory, PreviousState, ModalService, $location) {
        var allArtwork = [];
        var initialPosition;
        var post;
        var previousState;
        var promiseWatch;
        var self = this;
        var slides = [];

        // Add previous term to page if coming from tag page
        previousState = PreviousState.get();
        self.terms = [];
        if (previousState.url === 'tag/:tag') {
            self.terms.push({
                name: previousState.params.tag,
                state: 'index.tag',
                params: {
                    tag: previousState.params.tag
                }
            });
        }

        // Move carousel backward when left arrow clicked
        $scope.$on('artist:leftArrowClicked', function() {
            if (self.carouselIndex > 0) {
                self.setCarouselIndex(self.carouselIndex - 1);
                $scope.$apply();
            }
        });

        // Move carousel forward when right arrow clicked
        $scope.$on('artist:rightArrowClicked', function() {
            if (self.carouselIndex !== self.slides.length - 1) {
                self.setCarouselIndex(self.carouselIndex + 1);
                $scope.$apply();
            }
        });

        self.showEssay = $stateParams.show_response === 'true' ? false : true; //jshint ignore:line

        post = $filter('filter')(posts, {
            slug: $stateParams.artist
        });
        self.title = post[0].title;
        self.nameImage = post[0].acf.name_image.url; // jshint ignore:line
        slides = [];
        if (post[0].content) {
            slides.push({
                type: 'bio',
                description: post[0].content
            });
            self.bio = true;
        }
        slides = slides.concat(post[0].acf.artwork);
        if (post[0].acf.artwork.length > 1) {
            slides.push({
                type: 'allArtwork'
            });
        }
        self.slides = slides;
        // Fix initial slide bug
        // https://github.com/revolunet/angular-carousel/issues/296#issuecomment-74806403

        self.setShowEssay = function(show) {
            self.showEssay = show;
        };

        // Create all artwork to be passed to final slide
        angular.forEach(post[0].acf.artwork, function(artwork, i) {
            var increaseIndex = self.bio ? 1 : 0;
            allArtwork.push({
                index: i + increaseIndex,
                url: artwork.image.url
            });
        });
        self.allArtwork = allArtwork;

        initialPosition = parseInt($stateParams.index, 10);
        if (initialPosition) {
            self.carouselIndex = null;
            promiseWatch = $scope.$watch(function() {
                return self.carouselIndex;
            }, function(pos) {
                if (pos !== 0) {
                    // Will be fired for null value which we don't care about
                    return;
                }
                self.carouselIndex = initialPosition;
                // Remove watch after setting the position
                promiseWatch();
            });
        }

        $scope.$watch(function() {
            return self.carouselIndex;
        }, function() {
            // Update URL when index changes
            $location.search('index', self.carouselIndex).replace();
            self.shareUrl = $location.absUrl();
        });

        $scope.$on('rn-carousel-finish', function() {
            $('.scrollable-content').scrollTop(1);
            setTimeout(function() {
                $('.scrollable-content').scrollTop(0);
            }, 1);
        });

        // Fix carousel 'flash'
        self.carouselHidden = true;
        $timeout(function() {
            self.carouselHidden = false;
        }, 250);
        self.setCarouselIndex = function(index) {
            self.carouselIndex = index;
        };

        // Show fullscreen version of image in additional overlay
        self.fullscreen = function(imageUrl, scroll, embed) {
            ModalService.showModal({
                templateUrl: 'states/index.artist/fullscreen/fullscreen.html',
                controller: 'FullscreenCtrl',
                controllerAs: 'ctrl',
                appendElement: $('.state-artist'),
                inputs: {
                    image: imageUrl,
                    embed: embed,
                    scroll: scroll
                }
            }).then(function(modal) {
                $rootScope.modalOpen = true;
                modal.element.show().addClass('animate');
                modal.close.then(function() {
                    $rootScope.modalOpen = false;
                });
            });
        };

        // Special: open up a scrollable fullscreen modal
        $timeout(function() {
            $('.state-artist .fullscreen-scroll').click(function(e) {
                var $target = $(e.currentTarget);
                e.preventDefault();
                if ($target.data('embed')) {
                    // embed
                    self.fullscreen(null, true, $target.data('embed'));
                } else {
                    // image
                    self.fullscreen($target.attr('href'), true, null);
                }
            });
        });

        MetaFactory.set({
            title: post[0].title + ' | Storylines: Contemporary Art at the Guggenheim',
            description: 'View #Storylines artwork by ' + post[0].title,
            ogTitle: post[0].title + ' | Storylines: Contemporary Art at the Guggenheim',
            ogDescription: 'View #Storylines artwork by ' + post[0].title
        });

    }])
;
